import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { tiposDeRegistro as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoTiposDeRegistro as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { tiposDeRegistroGet } from '../../services/hooli-services/TiposDeRegistro/TiposDeRegistroGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function TiposDeRegistro() {
    const [tiposDeRegistro, setTiposDeRegistro] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const setRow = useSetRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, tiposDeRegistroGet, setTiposDeRegistro);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        tiposDeRegistro.map((item) => {
            const {
                tipoRegistroId,
                tipoRegistroNombre,
                tipoRegistroCod,
                tipoRegistroVersion,
            } = item

            const tipo = {
                id: tipoRegistroId,
                version: tipoRegistroVersion,
                [titles[0]]: tipoRegistroNombre,
                [titles[1]]: tipoRegistroCod,
            }

            setRows(rows => [...rows, tipo])
            return item
        });
    }, [tiposDeRegistro])

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="tipo de registro" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};